import isIRMRestricted from 'owa-mail-protection/lib/utils/isIRMRestricted';
import { ClientItem } from 'owa-mail-store';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';

export default function shouldDisableTranslate(
    irmRestrictions: IRMRestrictions,
    item: ClientItem
): boolean {
    return (
        isIRMRestricted(irmRestrictions) ||
        !item.TranslationData ||
        !item.TranslationData.userLanguage ||
        item.TranslationData.isShowingTranslation ||
        item.TranslationData.isTranslating
    );
}
